import { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, register as apiRegister, getCurrentUser } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('apaka_token');
      const savedUser = localStorage.getItem('apaka_user');
      
      if (token && savedUser) {
        try {
          const userData = await getCurrentUser();
          setUser(userData);
        } catch (error) {
          localStorage.removeItem('apaka_token');
          localStorage.removeItem('apaka_user');
        }
      }
      setLoading(false);
    };
    
    initAuth();
  }, []);

  const login = async (email, password) => {
    const response = await apiLogin({ email, password });
    localStorage.setItem('apaka_token', response.access_token);
    localStorage.setItem('apaka_user', JSON.stringify({
      id: response.user_id,
      role: response.role,
      organization_id: response.organization_id
    }));
    
    const userData = await getCurrentUser();
    setUser(userData);
    return userData;
  };

  const register = async (userData) => {
    const response = await apiRegister(userData);
    localStorage.setItem('apaka_token', response.access_token);
    localStorage.setItem('apaka_user', JSON.stringify({
      id: response.user_id,
      role: response.role,
      organization_id: response.organization_id
    }));
    
    const fullUserData = await getCurrentUser();
    setUser(fullUserData);
    return fullUserData;
  };

  const logout = () => {
    localStorage.removeItem('apaka_token');
    localStorage.removeItem('apaka_user');
    setUser(null);
    window.location.href = '/';
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    isAuthenticated: !!user,
    isCompany: user?.role === 'COMPANY',
    isFunder: user?.role === 'FUNDER',
    isAdmin: user?.role === 'ADMIN',
    token: localStorage.getItem('apaka_token'),
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
